{
  "api": {
    "locationValidationTitle": "Nie mogliśmy zweryfikować Twojej lokalizacji",
    "thresholdTitle": "Nie jesteś na czas do zameldowania",
    "warehouseUnavailableTitle": "Magazyn niedostępny",
    "warehouseUnavailableMessage": "Proszę skontaktować się z personelem obiektu w celu ręcznego zameldowania",
    "characterLimitTitle": "Dane wejściowe przekraczają limit znaków",
    "genericTitle": "Zameldowanie nie powiodło się. Proszę, spróbuj ponownie.",
    "recaptchaTitle": "Weryfikacja nie powiodła się",
    "recaptchaMessage": "Nie udało się zweryfikować Twojego żądania. Spróbuj ponownie lub skontaktuj się z personelem obiektu."
  }
}
